import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Droplets, ArrowLeft } from 'lucide-react';

const AvisoLegal = () => {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>Aviso Legal | Aqua Nexia</title>
        <meta name="description" content="Aviso legal de Aqua Nexia - Software de gestión para empresas de mantenimiento de piscinas." />
      </Helmet>

      {/* Header */}
      <header className="border-b bg-white sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-sky-600 flex items-center justify-center">
              <Droplets className="w-5 h-5 text-white" />
            </div>
            <span className="font-bold text-lg text-slate-900">Aqua Nexia</span>
          </Link>
          <Link to="/" className="text-sm text-sky-600 hover:text-sky-700 flex items-center gap-1">
            <ArrowLeft className="w-4 h-4" />
            Volver al inicio
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-slate-900 mb-8">Aviso Legal</h1>
        <p className="text-sm text-slate-500 mb-8">Última actualización: Febrero 2026</p>

        <div className="prose prose-slate max-w-none space-y-6 text-slate-700 leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-3">1. Datos identificativos</h2>
            <p>
              En cumplimiento del deber de información recogido en el artículo 10 de la Ley 34/2002, de 11 de julio, 
              de Servicios de la Sociedad de la Información y del Comercio Electrónico (LSSI-CE), a continuación se 
              reflejan los siguientes datos:
            </p>
            <ul className="list-disc pl-6 space-y-1 mt-3">
              <li><strong>Titular:</strong> [Nombre de la empresa o autónomo]</li>
              <li><strong>CIF/NIF:</strong> [Número de identificación fiscal]</li>
              <li><strong>Domicilio social:</strong> [Dirección completa]</li>
              <li><strong>Correo electrónico:</strong> info@aquanexia.com</li>
              <li><strong>Sitio web:</strong> aquanexia.com</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-3">2. Objeto</h2>
            <p>
              El presente aviso legal regula el uso y acceso al sitio web aquanexia.com (en adelante, el "Sitio Web"), 
              que Aqua Nexia pone a disposición de los usuarios de Internet. El acceso al Sitio Web atribuye la condición 
              de usuario e implica la aceptación plena y sin reservas de todas y cada una de las disposiciones incluidas 
              en este Aviso Legal.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-3">3. Propiedad intelectual e industrial</h2>
            <p>
              Todos los contenidos del Sitio Web, incluyendo, sin carácter limitativo, textos, fotografías, gráficos, 
              imágenes, iconos, tecnología, software, así como el diseño gráfico y código fuente, son propiedad intelectual 
              de Aqua Nexia o de terceros que han autorizado su uso, sin que puedan entenderse cedidos al usuario ninguno 
              de los derechos de explotación reconocidos por la normativa vigente en materia de propiedad intelectual.
            </p>
            <p>
              Las marcas, nombres comerciales y signos distintivos son propiedad de Aqua Nexia o de terceros, sin que 
              pueda entenderse que el acceso al Sitio Web atribuye algún derecho sobre los mismos.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-3">4. Condiciones de uso</h2>
            <p>El usuario se compromete a hacer un uso adecuado de los contenidos y servicios que Aqua Nexia ofrece, y a no emplearlos para:</p>
            <ul className="list-disc pl-6 space-y-1 mt-3">
              <li>Incurrir en actividades ilícitas, ilegales o contrarias a la buena fe y al orden público.</li>
              <li>Difundir contenidos o propaganda de carácter racista, xenófobo, pornográfico o que atente contra los derechos humanos.</li>
              <li>Provocar daños en los sistemas físicos y lógicos del Sitio Web, de sus proveedores o de terceros.</li>
              <li>Introducir o difundir virus informáticos o cualesquiera otros sistemas que puedan causar daño.</li>
              <li>Intentar acceder, utilizar o manipular los datos de terceros usuarios o del propio Sitio Web.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-3">5. Exclusión de responsabilidad</h2>
            <p>
              Aqua Nexia no se hace responsable de los daños y perjuicios que pudieran derivarse del uso inadecuado 
              de los servicios de la plataforma. Asimismo, queda exonerada de cualquier responsabilidad ante posibles 
              fallos técnicos, interrupciones del servicio o pérdida de datos derivados de causas ajenas a su control.
            </p>
            <p>
              El servicio SaaS se ofrece "tal cual" y Aqua Nexia se reserva el derecho de realizar modificaciones, 
              actualizaciones o interrupciones temporales del servicio para tareas de mantenimiento.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-3">6. Legislación aplicable y jurisdicción</h2>
            <p>
              Las presentes condiciones se rigen por la legislación española. Para la resolución de cualquier controversia, 
              las partes se someten a los Juzgados y Tribunales del domicilio social del titular del Sitio Web.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-3">7. Modificaciones</h2>
            <p>
              Aqua Nexia se reserva el derecho de modificar el presente Aviso Legal en cualquier momento, siendo 
              responsabilidad del usuario la revisión periódica del mismo.
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-8 px-4 border-t mt-12">
        <div className="max-w-4xl mx-auto flex flex-wrap items-center justify-center gap-4 text-sm text-slate-500">
          <Link to="/aviso-legal" className="hover:text-sky-600">Aviso Legal</Link>
          <span>·</span>
          <Link to="/politica-privacidad" className="hover:text-sky-600">Privacidad</Link>
          <span>·</span>
          <Link to="/terminos-condiciones" className="hover:text-sky-600">Términos</Link>
          <span>·</span>
          <Link to="/politica-cookies" className="hover:text-sky-600">Cookies</Link>
        </div>
      </footer>
    </div>
  );
};

export default AvisoLegal;
